import { ZodType } from "zod";

export const validateField = (
  schema: ZodType,
  value: any
): string | null => {
  const result = schema.safeParse(value);
  return result.success ? null : result.error.issues[0].message;
};
